import { FloatingFormItem, Group, InputDate } from '@/components/_common';
import { useDisclosure } from '@/hooks';
import { Button } from 'antd';

import './style.less';
import ComplementScheduleDateFieldEditModal from './EditModal';

type Props = {
  disabled?: boolean;
};

export default function ComplementScheduleDateField({ disabled }: Props) {
  const [opened, actions] = useDisclosure();

  return (
    <>
      <Group className="complement-schedule-date">
        <FloatingFormItem name="scheduleDateTime" label="Data de agendamento">
          <InputDate disabled showTime />
        </FloatingFormItem>

        <Button
          type="primary"
          size="large"
          disabled={disabled}
          onClick={actions.open}
        >
          Alterar
        </Button>
      </Group>

      <ComplementScheduleDateFieldEditModal
        opened={opened}
        onClose={actions.close}
      />
    </>
  );
}
